import { ApplicationLoader } from 'components/ApplicationLoader';
import { PageHeader } from 'components/Layout/PageHeader';
import { PageLayout } from 'components/Layout/PageLayout';
import { usePeriodDates } from 'hooks/usePeriodDates';
import queryString from 'query-string';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router';
import {
  DefaultEntriesTableLayout,
  EntriesTab,
  EntriesTableOptions,
} from '../components/DefaultEntriesTableLayout';
import { EntryFilter, useFetchEntries } from '../hooks/useFetchEntries';

export interface EntryPeriodRange {
  startDate: Date;
  endDate: Date;
}

const m = defineMessages({
  pageTitle: { id: 'Entries.Page.Title', defaultMessage: 'Entrées' },
});

export const EntriesPage: React.FC = () => {
  const { formatMessage } = useIntl();
  const location = useLocation();
  const history = useHistory();

  const options = queryString.parse(location.search);
  const currentTab = (options.tab as string) ?? 'myEntries';

  const entryTabToFilter = {
    myEntries: EntryFilter.MyEntries,
    myTeamEntries: EntryFilter.MyTeamEntries,
    allEntries: EntryFilter.AllEntries,
  };

  const {
    periodName,
    customPeriodDates,
    startDate,
    endDate,
    setPeriodName,
    setCustomPeriodDates,
  } = usePeriodDates();

  const { entries, isLoading: isLoadingEntries } = useFetchEntries(
    startDate,
    endDate,
    entryTabToFilter[currentTab as EntriesTab]
  );

  const handleOptionsChange = (options: EntriesTableOptions) => {
    history.replace({
      pathname: location.pathname,
      search: queryString.stringify(options),
    });
  };

  const isLoaded = !isLoadingEntries;

  return (
    <PageLayout pageTitle={formatMessage(m.pageTitle)}>
      <PageHeader
        header={formatMessage(m.pageTitle)}
        iconName="file alternate"
      />
      {isLoaded ? (
        <DefaultEntriesTableLayout
          entries={entries}
          options={options}
          onOptionsChange={handleOptionsChange}
          periodName={periodName}
          onPeriodChange={setPeriodName}
          setPeriodDates={setCustomPeriodDates}
          periodDates={customPeriodDates}
        />
      ) : (
        <ApplicationLoader />
      )}
    </PageLayout>
  );
};
